<template>
  <SideBarLayoutContent>
    <template #top-bar>
      <h1 class="text-display-small">{{ $t('mainNavigation.conductedDialogs') }}</h1>
    </template>
    <LoadingWrapper :state="status">
      <div v-if="data.length > 0" class="flex flex-col gap-2">
        <ul class="flex flex-col gap-2">
          <li v-for="dialog in data" :key="dialog.id">
            <ConductedDialogItem :conducted-dialog="dialog" @click="navigateToDialog(dialog.id)" />
          </li>
        </ul>
      </div>

      <EmptyPage
        v-if="data.length === 0"
        title="Keine durchgeführten Dialoge"
        description="Du hast noch keine durchgeführten Dialoge."
        icon="history"
      />
    </LoadingWrapper>
  </SideBarLayoutContent>
</template>

<script lang="ts" setup>
  import SideBarLayoutContent from '../../../core/components/layouts/SideBarLayoutContent.vue'
  import LoadingWrapper from '../../../core/components/loading/LoadingWrapper.vue'
  import EmptyPage from '../../../core/components/empty-states/EmptyPage.vue'

  import { useConductedDialogs } from '../composable/use-conducted-dialogs'
  import ConductedDialogItem from '../components/ConductedDialogItem.vue'
  import { useRouter } from 'vue-router'

  const { status, data } = useConductedDialogs()

  const router = useRouter()

  const navigateToDialog = (dialogId: string) => {
    router.push({ name: 'dialog', params: { id: dialogId } })
  }
</script>
